import { render, staticRenderFns } from "./productFrame.vue?vue&type=template&id=0ef94bbc&scoped=true"
import script from "./productFrame.vue?vue&type=script&lang=js"
export * from "./productFrame.vue?vue&type=script&lang=js"
import style0 from "./productFrame.vue?vue&type=style&index=0&id=0ef94bbc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef94bbc",
  null
  
)

export default component.exports